import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className="rx-theme-toggle flex items-center gap-2 h-9 px-3 rounded-lg font-rajdhani font-bold text-xs tracking-wide transition-all duration-200"
      title={isDark ? 'Switch to Daylight mode' : 'Switch to Night mode'}
      aria-label={isDark ? 'Switch to Daylight mode' : 'Switch to Night mode'}
    >
      {isDark ? (
        <>
          <Sun className="w-4 h-4 text-amber-300" />
          <span>DAYLIGHT</span>
        </>
      ) : (
        <>
          <Moon className="w-4 h-4 text-blue-600" />
          <span>NIGHT</span>
        </>
      )}
    </button>
  );
}
